import { createField } from "./haz-info.section";
import lodash from "lodash";

export const initForm = ({ props, data, refs }) => {
    const key = props.dataKey;
    const isLoading = props.isLoading;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    data.fields = createField({ props, data, refs, key, isLoading });
    if (model.id) {
        data.mainSubStance = {
            fetchCriteria: {
                select: ["**", "refSubStance.**"],
                page: 0,
                size: 1000000,
                where: [{ name: "refHaz.id", type: "UUID", operator: "=", value: model.id }],
                sort: [{ name: "createDate", type: "ASC" }],
                children: [
                    {
                        name: "companies",
                        select: [
                            "*",
                            "refUserCompany.id",
                            "refUserCompany.version",
                            "refUserCompany.companyNameTh",
                            "refUserCompany.companyNameEn",
                            "refUserCompany.fullNameTh",
                            "refUserCompany.fullNameEn",
                            "refUserCompany.refPersonType.*"
                        ],
                        page: 0,
                        size: 1000000,
                        children: [
                            {
                                name: "refUserCompany.hazes",
                                select: ["id", "version", "approveCode", "refUserCompany.id", "refUserCompany.version"],
                                page: 0,
                                size: 1000000,
                                where: [
                                    { name: "isActive", type: "Boolean", operator: "=", value: true },
                                    { name: "isTemp", type: "Boolean", operator: "=", value: false },
                                    { name: "refStatus.key", type: "String", operator: "!=", value: "cancel" },
                                    { name: "refType.key", type: "String", operator: "=", value: "1" }
                                ]
                            }
                        ]
                    },
                    {
                        name: "products",
                        select: [
                            "*",
                            "refHaz.id", "refHaz.version", "refHaz.approveCode",
                            "refHaz.refUserCompany.id", "refHaz.refUserCompany.version",
                            "refProduct.id", "refProduct.key", "refProduct.value",
                            "refProduct.refParent.id", "refProduct.refParent.key", "refProduct.refParent.value",
                        ],
                        page: 0,
                        size: 1000000
                    },
                    { name: "attachments", select: ["*"], page: 0, size: 1000000 }
                ]
            }
        };
    }
};
